import type { IStateTaxClassification } from '~/models/StateTaxClassification';
import { getAuthHeaders, tempMeeApi } from '~/services/api';

/**
 * The worker models one location's state allows, read with that location's
 * `x-office`: the endpoint answers for whichever office the header names.
 */
export const getOfficeWorkerClassification = async (
  officeId: string,
): Promise<IStateTaxClassification> => {
  const headers = await getAuthHeaders();
  const { data } = await tempMeeApi.get<IStateTaxClassification>(
    '/users/state-worker-classification',
    { headers: { ...headers, 'x-office': officeId } },
  );
  return data;
};
